import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BorderStyle = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="3" width="12" height="1.5" rx="0.75" fill={color} />
        <rect x="2" y="7.25" width="5" height="1.5" rx="0.75" fill={color} />
        <rect x="2" y="11.5" width="1.5" height="1.5" rx="0.75" fill={color} />
        <rect x="4.625" y="11.5" width="1.5" height="1.5" rx="0.75" fill={color} />
        <rect x="7.25" y="11.5" width="1.5" height="1.5" rx="0.75" fill={color} />
        <rect x="9.875" y="11.5" width="1.5" height="1.5" rx="0.749999" fill={color} />
        <rect x="12.5" y="11.5" width="1.5" height="1.5" rx="0.749999" fill={color} />
        <rect x="9" y="7.25" width="5" height="1.5" rx="0.75" fill={color} />
      </svg>
    )
  },
)

export default BorderStyle
